import Service from "../Service";
import Vue from "vue";
const resource = "detailTurn/"

export default {
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination2", parameters, {
            params: { requestID: requestID },
        });
    },

};